const icons: { [key: string]: PoiCategoryDetails } = {
  'GENERIC':                   { iconCategory: 'fa-star' },
  'ACCOMMODATION':             { iconCategory: 'fa-bed' },
  'LANDMARK':                  { iconCategory: 'fa-monument' },
  'VISTAPOINT':                { iconCategory: 'fa-binoculars' },
  'PHOTOOPPORTUNITY':          { iconCategory: 'fa-camera' },
  'ACTIVITY_SHOPPING':         { iconCategory: 'fa-shopping-bag' },
  'ACTIVITY_NATURE':           { iconCategory: 'fa-tree' },
  'ACTIVITY_WILDLIFE':         { iconCategory: 'fa-paw' },
  'ACTIVITY_WALKING':          { iconCategory: 'fa-shoe-prints' },
  'ACTIVITY_SPORT':            { iconCategory: 'fa-football-ball' },
  'ACTIVITY_WINTERSPORTS':     { iconCategory: 'fa-snowflake' },
  'ACTIVITY_MUSIC':            { iconCategory: 'fa-music' },
  'ACTIVITY_CULTURE':          { iconCategory: 'fa-theater-masks' },
  'ACTIVITY_MUSEUM':           { iconCategory: 'fa-landmark' },
  'ACTIVITY_EVENT':            { iconCategory: 'fa-ticket' },
  'ACTIVITY_DRIVE':            { iconCategory: 'fa-road' },
  'ACTIVITY_RELAX':            { iconCategory: 'fa-umbrella-beach' },
  'ACTIVITY_SPA':              { iconCategory: 'fa-spa' },
  'GEOGRAPHY_CAPITAL':         { iconCategory: 'fa-city' },
  'GEOGRAPHY_REGION':          { iconCategory: 'fa-map' },
  'GEOGRAPHY_CITY':            { iconCategory: 'fa-building' },
  'CULINARY_FOOD':             { iconCategory: 'fa-utensils' },
  'CULINARY_COFFEE':           { iconCategory: 'fa-coffee' },
  'CULINARY_BAR':              { iconCategory: 'fa-glass-martini-alt' },
  'CULINARY_PUB':              { iconCategory: 'fa-beer' },
  'CULINARY_NIGHTLIFE':        { iconCategory: 'fa-moon' },
  'TRANSPORTATION_TRAIN':      { iconCategory: 'fa-subway' },
  'TRANSPORTATION_PLANE':      { iconCategory: 'fa-plane' },
  'TRANSPORTATION_CAR':        { iconCategory: 'fa-car-alt' },
  'TRANSPORTATION_BUS':        { iconCategory: 'fa-bus' },
  'TRANSPORTATION_SHIP':       { iconCategory: 'fa-ship' },
  'TRANSPORTATION_MOTORCYCLE': { iconCategory: 'fa-motorcycle' },
  'TRANSPORTATION_BICYCLE':    { iconCategory: 'fa-bicycle' }
};

interface PoiCategoryDetails {
  iconCategory: string;
}

export function getPoiCategoryIconCategory(poiCategory: string): string | undefined {
  return icons[poiCategory]?.iconCategory ?? icons['GENERIC'].iconCategory;
}
